import { ICopyable } from '../controls/common/icopyable';
import { CriteriaSearchZone } from './enums/criteria-search-zone';
import { SearchMode } from './enums/search-mode';
import { SearchOptions } from './search-options';
import { SettingsBase } from './settings-base';

export class CustomerIdentificationSettings extends SettingsBase implements ICopyable<CustomerIdentificationSettings> {
    public issuer: string = null;
    public identifiedCustomerId: number = null;
    public searchExpression: string = null;
    public searchOptions: SearchOptions = new SearchOptions();
    public searchMode: SearchMode = SearchMode.None;
    public criteriaSearchZones: CriteriaSearchZone[] = [];

    public createCopy(): CustomerIdentificationSettings {
        const instance = new CustomerIdentificationSettings();
        instance.issuer = this.issuer;
        instance.identifiedCustomerId = this.identifiedCustomerId;
        instance.searchExpression = this.searchExpression;
        instance.searchOptions = this.searchOptions;
        instance.searchMode = this.searchMode;
        instance.criteriaSearchZones = this.criteriaSearchZones;
        instance.type = this.type;

        return instance;
    }

    public static createFrom(other: any): CustomerIdentificationSettings {
        const instance = new CustomerIdentificationSettings();
        instance.issuer = other.issuer;
        instance.identifiedCustomerId = other.identifiedCustomerId;
        instance.searchExpression = other.searchExpression;
        instance.searchOptions = other.searchOptions;
        instance.searchMode = other.searchMode;
        instance.criteriaSearchZones = other.criteriaSearchZones;
        instance.type = other.type;

        return instance;
    }

    public copyFrom(other: any) {
        this.issuer = other.issuer;
        this.identifiedCustomerId = other.identifiedCustomerId;
        this.searchExpression = other.searchExpression;
        this.searchOptions = other.searchOptions;
        this.searchMode = other.searchMode;
        this.criteriaSearchZones = other.criteriaSearchZones;
        this.type = other.type;
    }
}
